<form [formGroup]="generalForm">



  <!-- Vendor,sup,bro,dealer -->
  <div class="form-section">
    <div class="row">
      <div class="col-6">
        <div class="form-section">
          <div class="mb-3">
            <label for="serial" class="form-label">{{
              "inputs.serial" | translate
              }}</label>
            <div class="input-group div-copy">
              <input type="text" class="form-control" id="serial" #inputBrokerReference formControlName="serial"
                placeholder="{{
                  'inputs.serial' | translate
                }}" required />
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="form-section">
          <div class="mb-3">
            <label for="number" class="form-label">{{
              "inputs.number" | translate
              }}</label>
            <div class="input-group div-copy">
              <input type="text" class="form-control" id="number" #inputBrokerReference formControlName="number"
                placeholder="{{
                  'inputs.number' | translate
                }}" required />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <!-- <div class="col-4">
      <div class="form-section">
        <div class="mb-3">
          <label for="account_id" class="form-label">{{
            "inputs.account" | translate
            }}</label>
          <div class="input-group div-copy">
            <input type="text" class="form-control" id="account_id" #inputBrokerReference formControlName="account_id"
              placeholder="{{
                'inputs.reference' | translate
              }}" required />
          </div>
        </div>
      </div>
    </div> -->
    <div class="col-6">
      <div class="form-section">
        <div class="mb-4">
          <label for="organization_id" class="form-label">{{
            "inputs.organization" | translate
            }}</label>
          <ng-select formControlName="organization_id" [items]="organizationData" bindValue="reference" bindLabel="name"
            [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false">
          </ng-select>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="form-section">
        <div class="mb-4">
          <label for="dealership_id" class="form-label">{{
            "inputs.dealership" | translate
            }}</label>
          <ng-select formControlName="dealership_id" [items]="dealershipData" bindValue="reference" bindLabel="name"
            [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false">
          </ng-select>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="draft">
      <div class="row linea"></div>
    <div class="form-section">
      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label for="invoiced_at" class="form-label">{{ "inputs.invoiced_at"
              | translate }}
            </label>
            <mat-form-field appearance="fill">
              <input matInput [matDatepicker]="invoiced_at" formControlName="invoiced_at" placeholder="{{
                'inputs.invoiced_at' | translate
              }}" />
              <mat-datepicker-toggle matSuffix [for]="invoiced_at"></mat-datepicker-toggle>
              <mat-datepicker #invoiced_at></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label for="paid_at" class="form-label">{{ "inputs.paid_at"
              | translate }}
            </label>
            <mat-form-field appearance="fill">
              <input matInput [matDatepicker]="paid_at" formControlName="paid_at" placeholder="{{
                'inputs.paid_at' | translate
              }}" />
              <mat-datepicker-toggle matSuffix [for]="paid_at"></mat-datepicker-toggle>
              <mat-datepicker #paid_at></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="draft">
    <div class="form-section">
      <label for="stage" class="form-label">{{ "inputs.stage" | translate }}
        <span class="required">*</span></label>
      <div class="row">
        <div class="col-6">
          <div class="mb-3">

            <ng-select formControlName="stage" [items]="stages" bindValue="key"
              [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
              (change)="changeStage($event?.key)">
              <ng-template ng-label-tmp let-item="item">{{ "badge-status_select-stage." + item.key | translate }}</ng-template>
              <ng-template ng-option-tmp let-item="item">{{ "badge-status_select-stage." + item.key | translate }}</ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-6">
          <div class="btn-next">
            <button *ngIf="next_ok" type="submit" class="btn btn-primary btn-next_ok"
              (click)="onSubmitOrderFast(next_ok)"> <i class="icon-next-circle"></i>
              {{ "badge-status_select-stage."+ next_ok | translate }}
            </button>

            <button *ngIf="next_ko" type="submit" class="btn btn-primary btn-next_ko"
              (click)="onSubmitOrderFast(next_ko)"> <i class="icon-pause-circle"></i>
              {{ "badge-status_select-stage."+ next_ko | translate }}
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="mb-3">
          <label for="notes" class="form-label">{{
            "inputs.addnote" | translate
            }}</label>
          <textarea class="form-control textarea150" id="notes" rows="5" formControlName="notes"></textarea>
        </div>
      </div>
    </div>
  </div>
</form>
